import { createContext, useState } from "react";

const addCartItem = (cartItems, productToAdd) => {
    const existingCartItem = cartItems.find((cartItem) => productToAdd.id === cartItem.id);
    
    if (existingCartItem) {
        return cartItems.map((cartItem) => 
        cartItem.id === productToAdd.id ? 
            {...cartItem, quantity: cartItem.quantity + 1}
            : cartItem
        );
    }
        return [...cartItems, {...productToAdd, quantity: 1}];
};


export const CartContext = createContext({
    isCartOpen: false,
    setIsCartOpen: () => {},
    cartItems: [],
    addItemToCart: () => {},
    decreaseQuantity: () => {},
    removeItemFromCart: () => {}
})

export const CartProvider = ({children}) => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [cartItems, setCartItems] = useState([]); //hold cart items

    //add product to cart
    const addItemToCart = (productToAdd) => {
        setCartItems(addCartItem(cartItems, productToAdd));
    }

    //total count of items in cart
    const itemQuantity = cartItems.map((item) => item.quantity); 
    const cartTotal = itemQuantity.reduce((sum, num) => sum + num, 0);

    //decrease quantity
    const decreaseQuantity = (product) => {
        if (product.quantity > 1) {
            setCartItems (
                cartItems.map((cartItem) => 
                product.id === cartItem.id ? 
                {...cartItem, quantity: cartItem.quantity - 1}
                : cartItem ))
        } else {
            removeItemFromCart(product);
        }
    }

    //remove item
    const removeItemFromCart = (cartItemToRemove) => {
        setCartItems(
            cartItems.filter((item) => item.id !== cartItemToRemove.id)
        )
    }

    //total each item 
    const itemTotal = cartItems.map((item) => item.quantity * item.price); 
    //total all items 
    const allItemsTotal = itemTotal.reduce((sum, num) => sum + num, 0);

    
    const value = {isCartOpen, setIsCartOpen, addItemToCart, cartItems, cartTotal, decreaseQuantity, removeItemFromCart, allItemsTotal};
    
    return (
        <CartContext.Provider value={value}>{children}</CartContext.Provider>
    )
}